export const ACTION_RECAPTCHA = {
  LOGIN: "login_recaptcha",
  SIGN_UP: "sign_up_recaptcha",
  FORGET_PASSWORD: "forget_password_recaptcha",
  PASSWORD_RESET: "password_reset_recaptcha",
}
